export enum StateEnum {
  Init = 'init',
  Pristine = 'pristine',
  Dirty = 'dirty',
  Error = 'error',
  Warning = 'warning',
  Loading = 'loading',
  Created = 'created',
  Deleted = 'deleted',
}
